import classNames from 'classnames';
import RichText from '@/components/atoms/rich-text/rich-text';
import Typography from '@/components/atoms/typography/typography';
import CtaLinkList from '@/components/organisms/cta-link-list/cta-link-list';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';
import Row from '@/components/utilities/row/row';
import DateAndPricesTable from './date-and-prices-table/date-and-prices-table';
import styles from './date-and-prices.module.scss';

export interface DateAndPricesProps extends ModuleWrapperProps {
  /** The class name to apply */
  className?: string;
  /** An array of links to show */
  ctaLinks?: Content.Components['DateAndPricesModuleDto']['ctaLinks'];
  /** The text to show as a headline */
  headline?: Content.Components['DateAndPricesModuleDto']['headline'];
  /** The data to show in the table */
  table: Content.Components['DateAndPricesModuleDto']['table'];
  /** The text to show as a sub headline */
  text?: Content.Components['DateAndPricesModuleDto']['text'];
}

const DateAndPrices = ({
  className,
  ctaLinks = [],
  headline,
  table,
  text,
  ...rest
}: DateAndPricesProps) => {
  return (
    <ModuleWrapper
      {...rest}
      className={classNames(styles.component, className)}
    >
      <Container className={styles.container}>
        <Row className={styles.row}>
          <Column
            className={styles.headlineColumn}
            offset={{ desktop: 3, laptop: 2 }}
            width={{ desktop: 6, laptop: 8 }}
          >
            {headline && (
              <Typography className={styles.headline} tagStyle="displayMedium">
                {headline}
              </Typography>
            )}
          </Column>
        </Row>

        <Row className={styles.row}>
          <Column
            offset={{ desktop: table.columns.length > 6 ? 1 : 2 }}
            width={{ desktop: table.columns.length > 6 ? 10 : 8 }}
          >
            <DateAndPricesTable {...table} />
          </Column>
        </Row>

        <Row className={styles.row}>
          <Column
            className={styles.contentColumn}
            offset={{ desktop: 3, laptop: 2 }}
            width={{ desktop: 6, laptop: 8 }}
          >
            {ctaLinks.length > 0 && <CtaLinkList items={ctaLinks} />}

            {text && <RichText text={text} />}
          </Column>
        </Row>
      </Container>
    </ModuleWrapper>
  );
};

DateAndPrices.displayName = 'DateAndPrices';

export default DateAndPrices;
